// extracted by mini-css-extract-plugin
export default {"button":"BackButton_button__2Z2cq","icon":"BackButton_icon__ZqCpS","text":"BackButton_text__dOd5R"};